import { render, staticRenderFns } from "./PowerBIReporting.vue?vue&type=template&id=653b3022&scoped=true&"
import script from "./PowerBIReporting.vue?vue&type=script&lang=js&"
export * from "./PowerBIReporting.vue?vue&type=script&lang=js&"
import style0 from "./PowerBIReporting.vue?vue&type=style&index=0&id=653b3022&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b3022",
  null
  
)

/* custom blocks */
import block0 from "./PowerBIReporting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
